// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  features/bancoIntegracao/types.ts
//
//  Tipos NEUTROS de integração bancária por API (saldo, extrato, cobrança, PIX,
//  webhooks). Propositalmente SEM referência a um banco específico: o Banco Inter
//  é apenas a primeira implementação (ver providers/interProvider). Quando outro
//  banco entrar, ele mapeia suas respostas para ESTES tipos e as telas não mudam.
// ════════════════════════════════════════════════════════════════════════════

export interface BancoSaldo {
  disponivel: number;
  bloqueado: number;
  limite: number;
}

export interface ExtratoSyncResultado {
  contaCorrenteId: number;
  dataInicio: string;
  dataFim: string;
  qtdLidos: number;
  qtdImportados: number;
  qtdDuplicados: number;
}

export interface CobrancaOpcoes {
  numDiasAgenda?: number;
  multaPercentual?: number;
  moraPercentual?: number;
  descontoPercentual?: number;
  mensagem?: string;
  /// QR Code PIX no boleto: true/false força; null/omitido = padrão do contrato.
  comPix?: boolean | null;
}

export interface CobrancaResultado {
  interCobrancaId?: number;
  codigoSolicitacao: string;
  contaReceberId: number;
  valor: number;
  dtVencimento: string;
}

/** Cobrança já emitida (registro local, `GET /api/{inter-cobranca|sicoob-boleto}`). */
export interface CobrancaEmitida {
  /** codigoSolicitacao (Inter) ou nossoNúmero (Sicoob). */
  codigo: string;
  contaReceberId: number;
  numDocumento: string | null;
  nroParcela: number;
  clienteId: number;
  clienteNome: string | null;
  valorNominal: number;
  dtVencimento: string;
  dtEmissao: string;
  situacao: string | null;
}

export interface CobrancasEmitidasPagina {
  itens: CobrancaEmitida[];
  total: number;
  totalPaginas: number;
  pagina: number;
  tamanhoPagina: number;
}

export interface FiltroCobrancasEmitidas {
  dtInicio?: string;
  dtFim?: string;
  busca?: string;
  pagina?: number;
  tamanhoPagina?: number;
}

export interface CobrancaSituacao {
  codigoSolicitacao: string;
  situacao: string | null;
  valorNominal: number;
  dtVencimento: string;
  linhaDigitavel: string | null;
  codigoBarras: string | null;
  pixCopiaECola: string | null;
  pixTxid: string | null;
  baixaAplicada: boolean;
}

export interface PixCobRequest {
  valor: number;
  expiracaoSegundos?: number;
  devedorCpfCnpj?: string;
  devedorNome?: string;
  solicitacaoPagador?: string;
  contaReceberId?: number;
}

export interface PixCobvRequest {
  valor: number;
  dataVencimento: string;
  validadeAposVencimento?: number;
  devedorCpfCnpj?: string;
  devedorNome?: string;
  solicitacaoPagador?: string;
  contaReceberId?: number;
}

export interface PixCobResultado {
  txid: string;
  situacao: string | null;
  valor: number;
  pixCopiaECola: string | null;
  comVencimento: boolean;
  contaReceberId: number | null;
  baixaAplicada: boolean;
}

export interface PixDevolucaoResultado {
  e2eId: string;
  idDevolucao: string;
  status: string | null;
  valor: number;
}

/// Tipos de webhook (genéricos a qualquer banco que os ofereça).
export type WebhookTipo = 'Cobranca' | 'Pix' | 'PagamentoBoleto' | 'PagamentoPix';

export const WEBHOOK_TIPOS: { value: WebhookTipo; label: string }[] = [
  { value: 'Cobranca', label: 'Cobrança paga' },
  { value: 'Pix', label: 'PIX recebido' },
  { value: 'PagamentoBoleto', label: 'Status pagamento (boleto)' },
  { value: 'PagamentoPix', label: 'Status pagamento (PIX)' },
];
